/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIRequestContact
 */
export interface APIRequestContact {
    /**
     * 
     * @type {string}
     * @memberof APIRequestContact
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestContact
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestContact
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestContact
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestContact
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestContact
     */
    mobile?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestContact
     */
    language?: string;
}

/**
 * Check if a given object implements the APIRequestContact interface.
 */
export function instanceOfAPIRequestContact(value: object): value is APIRequestContact {
    return true;
}

export function APIRequestContactFromJSON(json: any): APIRequestContact {
    return APIRequestContactFromJSONTyped(json, false);
}

export function APIRequestContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRequestContact {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'mobile': json['mobile'] == null ? undefined : json['mobile'],
        'language': json['language'] == null ? undefined : json['language'],
    };
}

export function APIRequestContactToJSON(value?: APIRequestContact | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'email': value['email'],
        'phone': value['phone'],
        'mobile': value['mobile'],
        'language': value['language'],
    };
}

